import { useForm, Link } from '@inertiajs/react'
import Layout from '../Layout'

interface Props {
  errors?: string
}

export default function Login({ errors }: Props) {
  const { data, setData, post, processing } = useForm({
    email_address: '',
    password: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/session')
  }

  return (
    <Layout>
      <div className="max-w-md mx-auto mt-20">
        <div className="bg-white p-8 rounded-lg shadow">
          <h1 className="text-2xl font-bold text-[#202020] mb-6 text-center">Iniciar Sesión</h1>

          {errors && (
            <div className="bg-red-50 text-red-600 p-3 rounded mb-4">
              {errors}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={data.email_address}
                onChange={(e) => setData('email_address', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Contraseña</label>
              <input
                type="password"
                value={data.password}
                onChange={(e) => setData('password', e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#55ACEE]"
                required
              />
            </div>

            <button
              type="submit"
              disabled={processing}
              className="w-full bg-[#55ACEE] text-white py-2 rounded hover:bg-[#4a9dd4] transition-colors disabled:opacity-50"
            >
              {processing ? 'Ingresando...' : 'Ingresar'}
            </button>
          </form>

          <p className="mt-4 text-center text-sm text-gray-600">
            ¿No tienes cuenta?{' '}
            <Link href="/registrations/new" className="text-[#55ACEE] hover:underline">
              Regístrate aquí
            </Link>
          </p>
        </div>
      </div>
    </Layout>
  )
}
